import { gql } from "@apollo/client";

export const SEND_INVOICE_TO_VALIDATION = gql`
  mutation sendInvoiceToValidation($input: SendInvoiceToValidationInput!) {
    invoice {
      sendInvoiceToValidation(input: $input) {
        success
      }
    }
  }
`;
